import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import SearchField from "@components/ui/textfields/SearchField";
import { useProjectStore } from "@store/projectStore";
import { useState } from "react";
import { PartnerInfos } from "types";
import { CreatePartnerModal } from "./CreatePartnerModal";

export const AddPartnerToProjectModal = ({
  onClose,
  onSelect,
  existingPartnerIds,
}: {
  onClose: () => void;
  onSelect: (partner: PartnerInfos) => void;
  existingPartnerIds: string[];
}) => {
  const partners = useProjectStore((state) => state.partners);
  const [search, setSearch] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);

  const availablePartners = partners.filter(
    (p) => !existingPartnerIds.includes(p.id),
  );

  const getDisplayedPartners = () => {
    if (!search) {
      // Show 5 most recent (last added) when no search
      return availablePartners.slice(-5).reverse();
    }
    const s = search.toLowerCase();
    return availablePartners.filter(
      (p) =>
        p.display_name?.toLowerCase().includes(s) ||
        p.company_name?.toLowerCase().includes(s) ||
        p.role?.toLowerCase().includes(s),
    );
  };

  const displayed = getDisplayedPartners();

  const handleCreateAndSelect = (partner: PartnerInfos) => {
    onSelect(partner);
  };

  return (
    <>
      {showCreateModal && (
        <CreatePartnerModal
          onClose={() => setShowCreateModal(false)}
          onSave={handleCreateAndSelect}
        />
      )}
      <BaseModal
        title="Ajouter un intervenant"
        startIcon={<Icon1 name="expert" size={20} />}
        onClose={onClose}
      >
        <div className="flex flex-col gap-3 p-4">
          <SearchField
            value={search}
            onChange={(value) => setSearch(value)}
            placeholder="Rechercher un intervenant..."
          />
          {!search && availablePartners.length > 5 && (
            <div className="text-h4 text-neutral-400">
              5 intervenants les plus récents
            </div>
          )}
          <div className="flex flex-col gap-1 max-h-300 overflow-y-auto">
            {displayed.length === 0 && (
              <div className="text-h3 text-neutral-400 text-center py-4">
                Aucun intervenant trouvé
              </div>
            )}
            {displayed.map((partner) => (
              <div
                key={partner.id}
                onClick={() => {
                  onSelect(partner);
                  onClose();
                }}
                className="flex flex-row items-center gap-3 px-4 py-3 rounded-lg bg-white hover:bg-neutral-50 cursor-pointer border transition-colors"
              >
                <div className="flex flex-col flex-1">
                  <div className="text-h2 text-black font-medium">
                    {partner.company_name || partner.display_name}
                  </div>
                  <div className="text-h3 text-neutral-400">
                    {partner.role}
                    {partner.company_name && partner.display_name
                      ? ` - ${partner.display_name}`
                      : ""}
                  </div>
                </div>
                <Icon1 name="plus" size={16} />
              </div>
            ))}
          </div>
          <div className="border-t border-neutral-200 pt-3">
            <SecondaryButton
              startIcon={<Icon1 name="plus" size={16} />}
              label="Créer un intervenant"
              variant="large"
              onClick={() => setShowCreateModal(true)}
            />
          </div>
        </div>
      </BaseModal>
    </>
  );
};
